document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initMarquee();
  initGaleria();
  initVariantes();
  initAcordeon();
});

function initReveal() {
  var els = document.querySelectorAll('.dt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('dt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-dt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var meta = parseFloat(el.getAttribute('data-dt-contador'));
      var duracion = 1400;
      var inicio = null;
      function tick(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * meta);
        el.textContent = valor.toLocaleString('es-ES');
        if (progreso < 1) requestAnimationFrame(tick);
        else el.textContent = meta.toLocaleString('es-ES');
      }
      requestAnimationFrame(tick);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('.dt-marquee').forEach(function (wrap) {
    var track = wrap.querySelector('.dt-marquee-track');
    if (!track || track.dataset.dtCloned) return;
    track.dataset.dtCloned = '1';
    track.innerHTML += track.innerHTML;
  });
}

function initGaleria() {
  var galeria = document.querySelector('[data-dt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-dt-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-dt-mini]');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src || !principal) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = src;
        principal.style.opacity = '1';
      }, 150);
      minis.forEach(function (m) { m.classList.remove('dt-mini-activa'); });
      mini.classList.add('dt-mini-activa');
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-dt-form-producto]');
  if (!form) return;
  var variantesEl = document.querySelector('[data-dt-variantes-json]');
  if (!variantesEl) return;
  var variantes;
  try { variantes = JSON.parse(variantesEl.textContent); } catch (e) { return; }

  var grupos = form.querySelectorAll('[data-dt-opcion-grupo]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-dt-precio]');
  var precioCompareEl = document.querySelector('[data-dt-precio-compare]');
  var botón = form.querySelector('[data-dt-boton-comprar]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 0 });
  }

  function seleccionActual() {
    return Array.from(grupos).map(function (grupo) {
      var activo = grupo.querySelector('.dt-prod-variante-activa');
      return activo ? activo.getAttribute('data-valor') : null;
    });
  }

  function actualizar() {
    var seleccion = seleccionActual();
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = moneda(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = moneda(variante.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botón) {
      var span = botón.querySelector('span');
      if (variante.available) {
        botón.removeAttribute('aria-disabled');
        if (span) span.textContent = botón.getAttribute('data-texto-disponible');
      } else {
        botón.setAttribute('aria-disabled', 'true');
        if (span) span.textContent = botón.getAttribute('data-texto-agotado');
      }
    }
  }

  grupos.forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-dt-opcion-boton]');
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botones.forEach(function (b) {
          b.classList.remove('dt-prod-variante-activa');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('dt-prod-variante-activa');
        btn.setAttribute('aria-pressed', 'true');
        actualizar();
      });
    });
  });
}

function initAcordeon() {
  document.querySelectorAll('[data-dt-acordeon-item]').forEach(function (item) {
    var boton = item.querySelector('[data-dt-acordeon-boton]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('dt-acordeon-abierto');
      item.closest('[data-dt-acordeon]').querySelectorAll('[data-dt-acordeon-item]').forEach(function (i) {
        i.classList.remove('dt-acordeon-abierto');
      });
      if (!abierto) item.classList.add('dt-acordeon-abierto');
    });
  });
}
